import RichTextElement from './RichTextElement';
import RichTextElementPresets from './RichTextElementPresets';
import RichTextElementMetaData from './RichTextElementMetaData';
import RichTextElementProps from './RichTextElementProps';

export default {
  metaData: RichTextElementMetaData,
  elementClass: RichTextElement.elementClass,
  elementProps: RichTextElementProps,
  presets: RichTextElementPresets,
  methods: RichTextElement.methods
};
